import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, User } from 'lucide-react';
export function WhoWeAreModule() {
  const leadershipPreview = [{
    name: 'Matthew Butterworth',
    title: 'Founder & CEO'
  }, {
    name: 'Lewis Butterworth',
    title: 'Managing Director'
  }, {
    name: 'Ollie Butterworth',
    title: 'MD, Chiltern Defence'
  }];
  return <section className="bg-white py-24 border-t border-steel-100" data-id="element-323">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-324">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-325">
          <div data-id="element-326">
            <span className="text-cg-orange-600 font-bold uppercase tracking-widest text-sm mb-2 block" data-id="element-327">
              About Us
            </span>
            <h2 className="text-3xl font-bold text-navy-900 mb-6" data-id="element-328">
              Who We Are
            </h2>
            <p className="text-lg text-steel-600 leading-relaxed mb-6" data-id="element-329">
              Chiltern Global is the chosen supplier for protecting those who
              protect us. Since 2005, we have been a market-leading manufacturer
              of specialist equipment for the defence, police, prison, and
              medical sectors.
            </p>
            <p className="text-steel-600 leading-relaxed mb-8" data-id="element-330">
              Our team is driven by three core values: integrity, reliability,
              and innovation. These principles guide us in our objective of
              equipping those who serve on the front lines with high-quality
              equipment.
            </p>
            <Link to="/who-we-are" className="inline-flex items-center gap-2 text-navy-900 font-bold uppercase tracking-wider text-sm hover:text-cg-orange-600 transition-colors" data-id="element-331">
              Learn more about Chiltern Global{' '}
              <ArrowRight className="w-4 h-4" data-id="element-332" />
            </Link>
          </div>

          <div className="bg-slate-50 p-8 border border-steel-200 rounded-sm" data-id="element-333">
            <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-6 border-b border-steel-200 pb-4" data-id="element-334">
              Leadership Team
            </h3>
            <div className="space-y-4" data-id="element-335">
              {leadershipPreview.map((person, index) => <div key={index} className="flex items-center gap-4 bg-white p-4 border border-steel-100 rounded-sm" data-id="element-336">
                  <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center text-steel-400 flex-shrink-0" data-id="element-337">
                    <User className="w-5 h-5" data-id="element-338" />
                  </div>
                  <div data-id="element-339">
                    <h4 className="font-bold text-navy-900 text-sm" data-id="element-340">
                      {person.name}
                    </h4>
                    <span className="text-xs text-cg-orange-600 font-bold uppercase tracking-wider" data-id="element-341">
                      {person.title}
                    </span>
                  </div>
                </div>)}
            </div>
            <div className="mt-6 text-center" data-id="element-342">
              <p className="text-xs text-steel-500 italic" data-id="element-343">
                * Leadership profiles are illustrative placeholders.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}